import React, { useState } from 'react';

interface DownloadButtonProps {
  certificateId: string;
  onDownload: (id: string) => Promise<void>;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ certificateId, onDownload }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    setError(null);
    setIsDownloading(true);
    try {
      await onDownload(certificateId);
    } catch (err) {
      setError('Download failed. Please retry.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="download-action">
      <button
        className="secondary-button"
        onClick={handleDownload}
        disabled={isDownloading}
        aria-busy={isDownloading}
      >
        {isDownloading ? 'Preparing...' : 'Download Certificate'}
      </button>
      {error && <p className="error-text">{error}</p>}
    </div>
  );
};

export default DownloadButton;
